




























































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
} from "@vue/composition-api";
import Store from "@/store";
import { AccountApi, ProjectApi, ProjectDto } from "@/api";
import { UserInfo } from "@/store/modules/user/types";
import { MenuItem, menuItems as menuItemsData } from "./menuItems";

const Component = defineComponent({
  setup(props, vm) {
    const projectApi = new ProjectApi();
    const accountApi = new AccountApi();

    const nav = reactive({
      open: vm.root.$vuetify.breakpoint.lgAndUp,
    });

    /**
     * Computed values from store
     */
    const user = computed<UserInfo>(() => Store.getters["User/getUser"]);
    const projects = computed<ProjectDto[]>(
      () => Store.getters["User/getProjects"]
    );
    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );
    const projectHasFiles = computed(
      () => selectedProject.value?.hasProjectFiles
    );

    const showEmployerListMenu = (
      item: MenuItem,
      project: ProjectDto | null
    ) => {
      if (!project) return;

      // Reset property to prevent issues when switching between projects.
      item.hide = false;

      // Hide everything for Alleo. Employer should be directed to Alleo environment.
      if (project.isAlleoProject === true) {
        item.hide = true;
      } else if (item.route === "/settings/employeelist") {
        // eslint-disable-next-line no-param-reassign
        item.hide = project.useEmployeeList !== true;
      } else if (item.route === "/settings/authorize-settings") {
        // Show when authorize is false, so hide when true
        item.hide = project.authorize === true;
      } else if (item.route === "/settings/microsoft-entra") {
        item.hide = project.useEntraLogin !== true;
      } else if (item.route === "/files") {
        // eslint-disable-next-line no-param-reassign
        item.hide = project.hasProjectFiles !== true;
      } else if (item.route === "/subscriptions/expensive") {
        // eslint-disable-next-line no-param-reassign
        item.hide = project.expensiveSubscriptionCheckActive !== true;
      } else if (item.children) {
        item.children.forEach((child) => {
          showEmployerListMenu(child, project);
        });
      }

      // Never hide logout.
      if (item.route === "/auth/logout"){
        item.hide = false;
      }
    };

    /**
     * Computed values
     */
    const menuItems = computed(() => {
      menuItemsData.forEach((m) =>
        showEmployerListMenu(m, selectedProject.value)
      );
      return menuItemsData;
    });

    /**
     * Fetch from API and set stores
     */
    const fetchUserData = async () => {
      const { data } = await accountApi.accountGetProfile();
      Store.dispatch("User/setUser", data);
    };

    const fetchProjects = async () => {
      const { data } = await projectApi.projectGetProjects();
      Store.dispatch("User/setProjects", data);
    };

    /**
     * Set store values
     */
    const setSelectedProject = (projectId: number) => {
      const foundProject = projects.value.find(
        (project) => project.projectId === projectId
      );
      Store.dispatch("User/setSelectedProject", foundProject);
    };

    /**
     * UI Functions
     */
    const toggle = (): void => {
      nav.open = !nav.open;
    };

    const menuItemHasActiveChild = (item: MenuItem) => {
      return item?.children?.find((el: MenuItem) => {
        return vm.root.$route.path.indexOf(el.route) > -1;
      });
    };

    const computeNrOfOpenRequests = (item: string) => {
      if (item === "menu.postvak-in.title") {
        const foundProject = projects.value.filter((subItem) => {
          if (!selectedProject.value) return 0;
          return subItem.projectId === selectedProject.value.projectId;
        });

        return foundProject.length ? foundProject[0].numberOfOpenRequests : 0;
      }
      return "";
    };

    /**
     * Lifecycle Functions
     */
    onMounted(async () => {
      await fetchUserData();
      await fetchProjects();
    });

    return {
      menuItems,
      nav,
      projectHasFiles,
      projects,
      selectedProject,
      user,
      computeNrOfOpenRequests,
      menuItemHasActiveChild,
      setSelectedProject,
      toggle,
    };
  },
});

export default Component;
